import axios from 'axios';

import { CreatePortfolioDto, PortfolioDto, UpdatePortfolioDto } from '../interfaces/portfolio.dto';

class PortfolioService {
  /** Every portfolio of the company, in the order they are listed */
  async list(): Promise<PortfolioDto[]> {
    return (await axios.get<PortfolioDto[]>('company/portfolios')).data;
  }

  async create(dto: CreatePortfolioDto): Promise<PortfolioDto> {
    return (await axios.post<PortfolioDto>('company/portfolios', dto)).data;
  }

  /** A rename, a hand-over to another seat, or both */
  async update(portfolioId: string, dto: UpdatePortfolioDto): Promise<PortfolioDto> {
    return (await axios.patch<PortfolioDto>(`company/portfolios/${portfolioId}`, dto)).data;
  }

  /** Puts the seat on every unit in the portfolio, and on the ones filed into it later */
  async addCollaborator(portfolioId: string, investorId: string): Promise<PortfolioDto> {
    return (await axios.post<PortfolioDto>(`company/portfolios/${portfolioId}/collaborators`, { investorId })).data;
  }

  /** Takes the seat off every unit in the portfolio */
  async removeCollaborator(portfolioId: string, investorId: string): Promise<PortfolioDto> {
    return (await axios.delete<PortfolioDto>(`company/portfolios/${portfolioId}/collaborators/${investorId}`)).data;
  }

  /** The units keep their managers and collaborators; only the grouping goes */
  async remove(portfolioId: string): Promise<void> {
    await axios.delete(`company/portfolios/${portfolioId}`);
  }

  /** The full set, in the order they should be listed */
  async reorder(portfolioIds: string[]): Promise<void> {
    await axios.put('company/portfolios/order', { portfolioIds });
  }
}

export default new PortfolioService();
